import React from 'react';
import { motion } from 'framer-motion';
export function FinalCtaSection() {
  return <section id="pre-order" className="py-10 md:py-20 bg-brand-darkest relative text-center" data-id="element-197">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,rgba(0,212,255,0.15)_0%,transparent_70%)]" data-id="element-198"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-199">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl sm:text-4xl md:text-6xl font-heading font-black mb-4 md:mb-8 leading-tight" data-id="element-200">
          Your Smart T-Shirt.
          <br data-id="element-201" />
          Your Identity.
          <br data-id="element-202" />
          <span className="text-brand-cyan" data-id="element-203">Your Future.</span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-sm md:text-xl text-gray-400 mb-6 md:mb-12 max-w-2xl mx-auto" data-id="element-204">
          Be part of the wearable tech revolution. Get your Qtap Smart T-Shirt
          today and change how you connect forever.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6 md:mb-12" data-id="element-205">
          <a href="https://shop.qtap.me/collections/world-cup-2026-smart-t-shirt" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-brand-cyan hover:bg-brand-sky text-brand-darkest font-bold text-base md:text-xl py-3.5 md:py-5 px-8 md:px-10 rounded-full transition-all hover:shadow-[0_0_25px_rgba(0,212,255,0.6)] inline-flex items-center justify-center" data-id="element-206">
            Don't Miss This Limited Offer
          </a>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="text-xs md:text-sm text-gray-500" data-id="element-207">
          30-Day Money-Back Guarantee • Free Worldwide Shipping • Lifetime
          Digital Profile
        </motion.p>
      </div>
    </section>;
}